// 生成路由地址的组件 (这里要注意地址和组件的文件位置一定要对应上)
export default (name) => () => import(`@/${name}`)

// export default (name) => import(`@/${name}`)


// export default (name) => () => import("@/"+name)



// WEBPACK FOOTER //
// ./src/router/lazyLoading.js